module.exports = __webpack_public_path__ + "img/step30_b_stand_power_stacker_assembled.8ea5f466.png";